package com.exura.navigation.parameters

import kotlinx.browser.window
import org.w3c.dom.url.URL

/**
 * Constructs a path-relative URL (e.g., "/plan/create?id=1") based on the current location.
 *
 * The navigator expects the relative part only
 *
 * @param params Pairs of Key to Value. Pass null as a value to remove the parameter.
 */
fun currentPathWithParams(vararg params: Pair<String, String?>): String {
    val url = URL(window.location.href)

    params.forEach { (key, value) ->
        if (value == null) {
            url.searchParams.delete(key)
        } else {
            url.searchParams.set(key, value)
        }
    }

    // pathname starts with '/', search - '?', hash - '#'
    return "${url.pathname}${url.search}${url.hash}"
}

fun currentPageParams() : String {
    val url = URL(window.location.href)

    return url.search
}
